import { renderRichText } from "gatsby-source-contentful/rich-text";
import { BLOCKS } from "@contentful/rich-text-types";
import React from "react";
import { graphql, navigate } from "gatsby";
import Layout from "../components/common/Layout";
import SEO from "../components/common/SEO";
import AdultClasses from "../components/home/AdultClasses";
import AgeClasses from "../components/home/AgeClasses";
import Hero from "../components/home/Hero";
import MusicalTheater from "../components/home/MusicalTheater";
import Popup from "reactjs-popup";
import SummerDancing from "../components/home/SummerDancing";
import Divider from "../components/common/Divider";
import styled from "styled-components";
import { H3, P } from "../components/common/Typography";
import { renderFeatured } from "../components/home/News";
import IconClose from "../assets/icons/close.svg";
import { MEDIA_QUERIES } from "../config";

const StyledPopup = styled(Popup)`
  &-overlay {
    background: rgba(0, 0, 0, 0.9);
    overflow: auto;
  }
  &-content {
    padding: 0;
    border: none;
    background: #fff;
    width: auto;
    height: auto;
  }
`;

const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      return <P>{children}</P>;
    },
  },
};

export default function NewsArticle({ data }) {
  const article = data.contentfulNewsArticle;
  const isBrowser = typeof window !== "undefined";

  return (
    <Layout>
      <SEO title={article.title} />
      <main>
        <Hero />
        {isBrowser && (
          <StyledPopup
            lockScroll
            modal
            closeOnDocumentClick
            open={true}
            onClose={() => navigate("/")}
          >
            {close => (
              <>
                <IconClose
                  role="button"
                  css={`
                    position: fixed;
                    right: 32px;
                    top: 16px;
                    width: 32px;
                    height: auto;
                    fill: grey;
                    cursor: pointer;

                    ${MEDIA_QUERIES.mobile} {
                      position: absolute;
                      right: 16px;
                    }
                  `}
                  onClick={close}
                />
                <div
                  css={`
                    width: 1024px;
                    padding: 32px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    min-width: unset;

                    ${MEDIA_QUERIES.desktop} {
                      width: unset;
                      padding: 32px 16px;
                      max-width: 1024px;
                    }
                  `}
                >
                  <div
                    css={`
                      margin-bottom: 4px;
                      font-size: 14px;
                      line-height: 1.57;
                    `}
                  >
                    {article.date}
                  </div>
                  <H3
                    as="h1"
                    css={`
                      margin-bottom: 32px;
                    `}
                  >
                    {article.title}
                  </H3>
                  <div
                    css={`
                      margin-bottom: 32px;
                    `}
                  >
                    {renderFeatured(article)}
                  </div>
                  <div
                    css={`
                      text-align: center;
                    `}
                  >
                    {article.content &&
                      renderRichText(article.content, options)}
                  </div>
                </div>
              </>
            )}
          </StyledPopup>
        )}
        <AdultClasses />
        <Divider />
        <AgeClasses />
        <Divider />
        <MusicalTheater />
        <Divider />
        <SummerDancing />
      </main>
    </Layout>
  );
}

export const pageQuery = graphql`
  query NewsArticleById($id: String!) {
    contentfulNewsArticle(contentful_id: { eq: $id }) {
      date(formatString: "DD/MM/YY")
      contentful_id
      order
      title
      content {
        raw
      }
      youtubeEmbed
      featuredImageOrVideo {
        file {
          contentType
          url
        }
        fixed(width: 600) {
          src
        }
      }
    }
  }
`;
